import React from "react";
import { HomeCategories } from "../Home/HomeCategories";
import { HomeTopCategories } from "../Home/HomeTopCategories";

function Home() {
    return (
        <React.Fragment>
            <HomeCategories />
            <HomeTopCategories />
        </React.Fragment>
    )
}

export { Home }
